var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('material-team-members-table',{attrs:{"headers":_vm.headers,"members":_vm.members,"limit":_vm.limit}})}
var staticRenderFns = []

export { render, staticRenderFns }